<script>
import Spinner from "../../components/Spinner"
import Section from "../../components/PageSection"

import {updateMontant} from '../../mixins/updateMontant.js';
import {allAboutDates} from '../../mixins/allAboutDates.js';

export default {
  name: 'menu4',
  components:{
    Spinner,
    Section,
  },
  data(){
    return{
      fullyLoadedGlobal: false,
      fullyLoadedDetails: false,
      phases: [],
      ultraDetailsArray: [], // Pour le tableau 2 avec le détail complet de chaque phase
      ultraDetailsPhaseSelected: 'all',
      modeSaisie: null,
      errCoeffs: [],
      arrayOfDebug: [],
      payload: {},
    }
  },
  mounted(){
    //Chargement des phases du projet (j'ai commenté car c'est finalement triggered par le watcher dans created)
    // this.phasesSurPeriod()
    // this.loadAllPhase()

  },
  created(){
      this.$store.watch(
        //Quand currentPeriod change de valeur
        (state) => {
          return state.auth.currentPeriod
        },
        //Alors j'execute j'exécute ce callback
        (newValue, oldValue) => {
          //Je vérifie que la nouvelle valeur est différente de la première pour ne pas lancer deux fois la requête, notamment au chargement (mounted + watcher)
          //J'ai enlevé de mounted car ça se lance quand même si j'actualise...
          // if (newValue.debut == oldValue.debut && newValue.fin == oldValue.fin){
            // console.log("valeurs inchangées")
            console.log(oldValue)
          // } else {
            //Si j'ai bien une date de début et de fin, je fait une réquète bornée dans le temps, sinon je fait une réquète globale (la même que dans mounted)
            if (newValue.debut && newValue.fin){
              this.phasesSurPeriod(newValue.debut, newValue.fin)
              this.loadAllPhase()
            } else {
              this.phasesSurPeriod()
              this.loadAllPhase()
            }
          // }
        },
        //Optional Deep if you need it
        {deep:true}
      )
    },
  watch: {
    ultraDetailsPhaseSelected(newVal) {
      console.log('ultraDetailsPhaseSelected changed', newVal)
    }
  },
  computed: {
    //Bilan
    etudes(){
      return this.phases.filter(e => e.type === 0);
    },
    chantier(){
      return this.phases.filter(e => e.type === 1);
    },
    missionsComplementaires(){
      return this.phases.filter(e => e.type === 2);
    },
    megaTotal(){
      let result = {}

        result.montant      = Math.round(this.phases.reduce((a, b) => a + (b['montant'] || 0), 0))
        result.factured     = Math.round(this.phases.reduce((a, b) => a + (b['factured'] || 0), 0))
        result.jours        = Math.round(this.phases.reduce((a, b) => a + (b['jours'] || 0), 0) * 10)/ 10
        result.salaires     = Math.round(this.phases.reduce((a, b) => a + (b['salaires'] || 0), 0))
        result.salairesCoeff= Math.round(this.phases.reduce((a, b) => a + (b['salairesCoeff'][this.$store.state.auth.currentCoeff] || 0), 0))
        result.frais        = Math.round(this.phases.reduce((a, b) => a + (b['frais'] || 0), 0))
        result.prestations  = Math.round(this.phases.reduce((a, b) => a + (b['prestations'] || 0), 0))

        result.total        = Math.round(result.salairesCoeff + result.frais + result.prestations)
        result.deltaFactured= Math.round(result.factured - result.total)
        result.delta        = Math.round(result.montant - result.total)

      return result
    },
    // getAnalyseTt(){

    //   let delta = {
    //     ttFacture:0,
    //     ttFrais:0,
    //     ttManPower:0,
    //     ttTime: 0,
    //     tt: 0
    //   }
    //   let coeff  = this.analyseProjet.coeffs.find(item => item.labelId == this.$store.state.auth.currentCoeff).val

    //   for (let i = 0 ; i < this.analyseProjet.frais.length; i++){
    //     delta.ttFrais += this.analyseProjet.frais[i].montant
    //   }
    //   for (let i = 0 ; i < this.analyseProjet.factures.length; i++){
    //     // console.log( this.analyseProjet.factures[i])
    //     delta.ttFacture += this.analyseProjet.factures[i].montantHT
    //   }
    //   for (let i = 0 ; i < this.analyseProjet.tempsPasses.length; i++){
    //     if(this.analyseProjet.tempsPasses[i].jours>0){
    //       delta.ttManPower += (this.analyseProjet.tempsPasses[i].jours * this.analyseProjet.tempsPasses[i].avgSbj)*coeff
    //       delta.ttTime += this.analyseProjet.tempsPasses[i].jours 
    //     }
    //   }

    //   delta.tt = delta.ttFacture- (delta.ttManPower+ delta.ttFrais)

    //   // console.log(delta)
    //   return delta
    // },
    errCurrentCoeff(){
      //Parmis tous les couples {coeff; année} pour lesquelles je n'ai pas de valeur (le tableau errCoeffs), lesquels concerne le coeff affiché ? Si aucune, je pourrais afficher le bilan, sinon un message d'erreur.
      return this.errCoeffs.filter(e => e._id === this.$store.state.auth.currentCoeff);
    },
    coeffValue(){
      let coeff  = this.analyseProjet.coeffs.find(item => item.labelId == this.$store.state.auth.currentCoeff)
      // console.log(coeff)
      return coeff.val
    },
    filteredUltraDetails() {
      const rows = this.ultraDetailsArray?.payload?.tempsPasses || [];

      // 🔹 Cas 1 : une phase précise est sélectionnée
      if (this.ultraDetailsPhaseSelected !== 'all') {
        return rows.filter(
          r => r.phaseId === this.ultraDetailsPhaseSelected
        );
      }

      // 🔹 Cas 2 : toutes les phases → somme par user
      const map = {};

      for (const r of rows) {
        if (!map[r.userId]) {
          map[r.userId] = {
            userId: r.userId,
            userName: r.userName,
            userSurname: r.userSurname,
            totalJours: 0,
            montants: {},
            sbjPondere: r.sbjPondere,
          };
        }
        map[r.userId].totalJours += r.totalJours;

        // 👇 agrégation des montants (tous les coeffs)
        for (const [coeffId, val] of Object.entries(r.montants || {})) {
          map[r.userId].montants[coeffId] =
            (Number(map[r.userId].montants[coeffId]) || 0) + (Number(val) || 0);
        }
      }

      return Object.values(map);
    },
    totalJoursUltraDetails() {
      return this.filteredUltraDetails.reduce(
        (sum, line) => sum + (Number(line.totalJours) || 0),
        0
      );
    },
    totalMontantAffiche() {
      const key = this.$store.state.auth.currentCoeff;

      return this.filteredUltraDetails.reduce(
        (sum, line) => sum + (Number(line.montants?.[key]) || 0),
        0
      );
    },
    filteredFrais() {
      const rows = this.ultraDetailsArray?.payload?.frais || [];

      if (this.ultraDetailsPhaseSelected === 'all') return rows;

      return rows.filter(r => r.phaseId === this.ultraDetailsPhaseSelected);
    },

    totalFraisAffiche() {
      return this.filteredFrais.reduce(
        (sum, r) => sum + (Number(r.montant) || 0),
        0
      );
    },
  },
  mixins:[
    updateMontant,
    allAboutDates,
  ],
  methods: {
    async phasesSurPeriod(debut, fin){
      this.fullyLoadedGlobal = false

      const promisePhases = this.$axios.get('analyseProjet/detailParPhases/' + this.$route.params._id + '/' + this.$store.state.auth.currentAgence._id + '/' + debut + '/' + fin)
      .then(response => {
        this.phases = response.data.phases
        this.errCoeffs = response.data.errCoeffs
      })
      .catch(err => this.alert(err))

      await Promise.all([promisePhases])
      this.fullyLoadedGlobal = true
    },
    styleDelta(phase){
      let result = phase.montant - phase.salairesCoeff[this.$store.state.auth.currentCoeff] - phase.frais - phase.prestations

      if (phase.delta){ //pour les totaux de chaque phase
        if (phase.delta < 0) {
          return "bilan__alert"
        } else {
          return "bilan__green"
        }
      } else {
        if (result < 0 ){
          return "bilan__alert"
        } else {
          return "bilan__green"
        }
      }
    },
    styleDeltaFactured(phase){
      let result = phase.factured - phase.salairesCoeff[this.$store.state.auth.currentCoeff] - phase.frais - phase.prestations

      if (phase.deltaFactured){ //pour les totaux de chaque phase
        if (phase.deltaFactured < 0) {
          return "bilan__alert"
        } else {
          return "bilan__green"
        }
      } else {
        if (result < 0 ){
          return "bilan__alert"
        } else {
          return "bilan__green"
        }
      }
    },
    total(array){
      let result = {}

      if (array.length > 0){
        result.montant      = Math.round(array.reduce((a, b) => a + (b['montant'] || 0), 0))
        result.factured     = Math.round(array.reduce((a, b) => a + (b['factured'] || 0), 0))
        result.jours        = Math.round(array.reduce((a, b) => a + (b['jours'] || 0), 0) * 10)/ 10
        result.salaires     = Math.round(array.reduce((a, b) => a + (b['salaires'] || 0), 0))
        result.salairesCoeff= Math.round(array.reduce((a, b) => a + (b['salairesCoeff'][this.$store.state.auth.currentCoeff] || 0), 0))
        result.frais        = Math.round(array.reduce((a, b) => a + (b['frais'] || 0), 0))
        result.prestations  = Math.round(array.reduce((a, b) => a + (b['prestations'] || 0), 0))

        result.total        = Math.round(result.salairesCoeff + result.frais + result.prestations)
        result.deltaFactured= Math.round(result.factured - result.total)
        result.delta        = Math.round(result.montant - result.total)
      }

      return result;
    },

    async loadAllPhase(phase){
      this.fullyLoadedDetails = false
      if (phase){
        await this.$axios.get('analyseProjet/loadAllPhases/' + this.$route.params._id + '/' + this.$store.state.auth.currentAgence._id + '/' + this.$store.state.auth.currentPeriod.debut + '/' + this.$store.state.auth.currentPeriod.fin +'/'+ phase)
        .then(rep => this.ultraDetailsArray = rep.data)
        .catch(err => this.alert(err))
        // console.log(this.analyseProjet)
      }else{
        await this.$axios.get('analyseProjet/loadAllPhases/' + this.$route.params._id + '/' + this.$store.state.auth.currentAgence._id + '/' + this.$store.state.auth.currentPeriod.debut + '/' + this.$store.state.auth.currentPeriod.fin)
        .then(rep => this.ultraDetailsArray = rep.data)
        .catch(err => this.alert(err))
        // console.log(this.analyseProjet)
      }
      // console.log(this.analyseProjet.tempsPasses)
      this.fullyLoadedDetails = true

    },

    async loadModeSaisie(){
      this.modeSaisie = await this.$axios.get('agences/mode/' + this.$store.state.auth.currentAgence._id)
    },

    debug(){
      this.$axios.get('analyseProjet/debug/' + this.$route.params._id + '/' + this.$store.state.auth.currentAgence._id + '/' + this.$store.state.auth.currentCoeff)
      .then(response => {
        // let pdfMake = require('pdfmake/build/pdfmake.js')
        // if (pdfMake.vfs == undefined){
        //     let pdfFonts = require('pdfmake/build/vfs_fonts.js')
        //     pdfMake.vfs = pdfFonts.pdfMake.vfs;
        // }

        this.arrayOfDebug = response.data.payload
      })
      .catch(err => this.alert(err))
    },
    onChange(event){
      // console.log(event.target.value)
      this.loadAllPhase(event.target.value)
    }
    },
}
</script>


<template>
  <div class="mainAnalyse">
    <div v-if="!fullyLoadedGlobal" class="mainWidth"><Spinner/></div>
    <Section v-else text="Bilan global" class="bilanGlobal">
      <template v-slot:body>
        <div v-if="errCurrentCoeff.length == 0" class="mainAnalyse__widget bilan">
          <div v-if="etudes.length">
            <div class="bilan__title">Etudes</div>
            <div class="bilan__grid bilan__legend">
              <span>Phases</span>
              <span>Honoraires HT</span>
              <span>Facturé HT</span>
              <span>Jours travaillés</span>
              <span>Sal. bruts x coeff</span>
              <span>Notes de frais</span>
              <span>Prestations Ext.</span>
              <span>Total</span>
              <span>&Delta; avec la facturation</span>
              <span>&Delta; avec les honoraires</span>
            </div>
            <div class="bilan__grid bilan__line" v-for="phase in etudes" :key="phase._id">
              <span> {{phase.name}} </span>
              <span> {{updateMontant(phase.montant).str}} €</span>
              <span> {{updateMontant(phase.factured).str}} €</span>
              <span> {{phase.jours}} </span>
              <span> {{updateMontant(phase.salairesCoeff[$store.state.auth.currentCoeff]).str}} €</span>
              <span> {{updateMontant(phase.frais).str}} €</span>
              <span> {{updateMontant(phase.prestations).str}} €</span>
              <span> {{updateMontant(phase.salairesCoeff[$store.state.auth.currentCoeff] + phase.frais + phase.prestations).str}} €</span>
              <span :class="styleDeltaFactured(phase)"> {{updateMontant(phase.factured - phase.salairesCoeff[$store.state.auth.currentCoeff] - phase.frais - phase.prestations).str}} €</span>
              <span :class="styleDelta(phase)"> {{updateMontant(phase.montant - phase.salairesCoeff[$store.state.auth.currentCoeff] - phase.frais - phase.prestations).str}} €</span>
            </div>
            <div class="bilan__grid bilan__total">
              <span>Total :</span>
              <span> {{updateMontant(total(etudes).montant).str}} €</span>
              <span> {{updateMontant(total(etudes).factured).str}} €</span>
              <span> {{total(etudes).jours}} </span>
              <span> {{updateMontant(total(etudes).salairesCoeff).str}}€</span>
              <span> {{updateMontant(total(etudes).frais).str}} €</span>
              <span> {{updateMontant(total(etudes).prestations).str}} €</span>
              <span> {{updateMontant(total(etudes).total).str}}€</span>
              <span :class="styleDeltaFactured(total(etudes))"> {{updateMontant(total(etudes).deltaFactured).str}} €</span>
              <span :class="styleDelta(total(etudes))"> {{updateMontant(total(etudes).delta).str}} €</span>
            </div>
          </div>

          <div v-if="chantier.length">
            <div class="bilan__title">Chantier</div>
            <div class="bilan__grid bilan__legend">
              <span>Phases</span>
              <span>Honoraires HT</span>
              <span>Facturé HT</span>
              <span>Jours travaillés</span>
              <span>Sal. bruts x coeff</span>
              <span>Notes de frais</span>
              <span>Prestations Ext.</span>
              <span>Total</span>
              <span>&Delta; avec la facturation</span>
              <span>&Delta; avec les honoraires</span>
            </div>
            <div class="bilan__grid bilan__line" v-for="phase in chantier" :key="phase._id">
              <span> {{phase.name}} </span>
              <span> {{updateMontant(phase.montant).str}} €</span>
              <span> {{updateMontant(phase.factured).str}} €</span>
              <span> {{phase.jours}} </span>
              <span> {{updateMontant(phase.salairesCoeff[$store.state.auth.currentCoeff]).str}} €</span>
              <span> {{updateMontant(phase.frais).str}} €</span>
              <span> {{updateMontant(phase.prestations).str}} €</span>
              <span> {{updateMontant(phase.salairesCoeff[$store.state.auth.currentCoeff] + phase.frais + phase.prestations).str}} €</span>
              <span :class="styleDeltaFactured(phase)"> {{updateMontant(phase.factured - phase.salairesCoeff[$store.state.auth.currentCoeff] - phase.frais - phase.prestations).str}} €</span>
              <span :class="styleDelta(phase)"> {{updateMontant(phase.montant - phase.salairesCoeff[$store.state.auth.currentCoeff] - phase.frais - phase.prestations).str}} €</span>
            </div>
            <div class="bilan__grid bilan__total">
              <span>Total :</span>
              <span> {{updateMontant(total(chantier).montant).str}} €</span>
              <span> {{updateMontant(total(chantier).factured).str}} €</span>
              <span> {{total(chantier).jours}} </span>
              <span> {{updateMontant(total(chantier).salairesCoeff).str}}€</span>
              <span> {{updateMontant(total(chantier).frais).str}} €</span>
              <span> {{updateMontant(total(chantier).prestations).str}} €</span>
              <span> {{updateMontant(total(chantier).total).str}} €</span>
              <span :class="styleDeltaFactured(total(chantier))"> {{updateMontant(total(chantier).deltaFactured).str}} €</span>
              <span :class="styleDelta(total(chantier))"> {{updateMontant(total(chantier).delta).str}} €</span>
            </div>
          </div>

          <div v-if="missionsComplementaires.length">
            <div class="bilan__title">Missions complémentaires</div>
            <div class="bilan__grid bilan__legend">
              <span>Phases</span>
              <span>Honoraires HT</span>
              <span>Facturé HT</span>
              <span>Jours travaillés</span>
              <span>Sal. bruts x coeff</span>
              <span>Notes de frais</span>
              <span>Prestations Ext.</span>
              <span>Total</span>
              <span>&Delta; avec la facturation</span>
              <span>&Delta; avec les honoraires</span>
            </div>
            <div class="bilan__grid bilan__line" v-for="phase in missionsComplementaires" :key="phase._id">
              <span> {{phase.name}} </span>
              <span> {{updateMontant(phase.montant).str}} €</span>
              <span> {{updateMontant(phase.factured).str}} €</span>
              <span> {{phase.jours}} </span>
              <span> {{updateMontant(phase.salairesCoeff[$store.state.auth.currentCoeff]).str}} €</span>
              <span> {{updateMontant(phase.frais).str}} €</span>
              <span> {{updateMontant(phase.prestations).str}} €</span>
              <span> {{updateMontant(phase.salairesCoeff[$store.state.auth.currentCoeff] + phase.frais + phase.prestations).str}} €</span>
              <span :class="styleDeltaFactured(phase)"> {{updateMontant(phase.factured - phase.salairesCoeff[$store.state.auth.currentCoeff] - phase.frais - phase.prestations).str}} €</span>
              <span :class="styleDelta(phase)"> {{updateMontant(phase.montant - phase.salairesCoeff[$store.state.auth.currentCoeff] - phase.frais - phase.prestations).str}} €</span>
            </div>
            <div class="bilan__grid bilan__total">
              <span>Total :</span>
              <span> {{updateMontant(total(missionsComplementaires).montant).str}} €</span>
              <span> {{updateMontant(total(missionsComplementaires).factured).str}} €</span>
              <span> {{total(missionsComplementaires).jours}} </span>
              <span> {{updateMontant(total(missionsComplementaires).salairesCoeff).str}} €</span>
              <span> {{updateMontant(total(missionsComplementaires).frais).str}} €</span>
              <span> {{updateMontant(total(missionsComplementaires).prestations).str}} €</span>
              <span> {{updateMontant(total(missionsComplementaires).total).str}} €</span>
              <span :class="styleDeltaFactured(total(missionsComplementaires))"> {{updateMontant(total(missionsComplementaires).deltaFactured).str}} €</span>
              <span :class="styleDelta(total(missionsComplementaires))"> {{updateMontant(total(missionsComplementaires).delta).str}} €</span>
            </div>
          </div>
          <div class="bilan__grid bilan__megaTotal">
              <span>Total projet :</span>
              <span> {{updateMontant(megaTotal.montant).str}} €</span>
              <span> {{updateMontant(megaTotal.factured).str}} €</span>
              <span> {{megaTotal.jours}} </span>
              <span> {{updateMontant(megaTotal.salairesCoeff).str}} €</span>
              <span> {{updateMontant(megaTotal.frais).str}} €</span>
              <span> {{updateMontant(megaTotal.prestations).str}} €</span>
              <span> {{updateMontant(megaTotal.total).str}} €</span>
              <span :class="styleDeltaFactured(megaTotal)"> {{updateMontant(megaTotal.deltaFactured).str}} €</span>
              <span :class="styleDelta(megaTotal)"> {{updateMontant(megaTotal.delta).str}} €</span>
          </div>
        </div>
        <div v-else class="mainAnalyse__widget mainAnalyse__widget__erreur">
          <p>
            Pas de valeur saisie pour le coefficient "{{errCurrentCoeff[0].name}}" sur la ou les années suivantes :
            <ul>
              <li v-for="item in errCurrentCoeff" :key="item.annee"> {{item.annee}} </li>
            </ul>
          </p>
        </div>
      </template>
    </Section>

    <!--<Section text="Debug" v-if="can('lecture','res')" class="bilanGlobal">-->
    <Section text="Debug" class="bilanGlobal"> 
      <template v-slot:body>
        <div v-if="errCurrentCoeff.length == 0" class="mainAnalyse__widget bilan">
          <button @click="debug()"> debug </button>
          <div v-for="phase in arrayOfDebug" :key="phase.name">
            <div style="margin: 15px 0 5px 0;">{{phase.name}} : {{phase.jours}}j. > {{phase.total}}€ </div>
            <div v-for="line in phase.data" :key="line.date" style="font-size: 14px;">
              {{line.date}} :
              {{line.tempsJours}}{{line.tempsHeures}}<span v-if="line.tempsJours">j.</span><span v-else>h.</span>
              ({{line.equiv}} j.) -
              {{line.userName}} ({{line.salaireUser}}) : {{(line.salaireUser / line.nbJours).toFixed(2)}} * {{line.coeff}} * {{line.equiv}} = {{line.produit}} || {{line.cumul}}
              <!-- <br>
              {{line}} -->
            </div>
          </div>
        </div>
      </template>
    </Section>

    <div v-if="!fullyLoadedDetails" class="mainWidth"><Spinner/></div>
    <Section v-else text="Détails des coûts" class="bilanGlobal">
      <template v-slot:body>
        <div v-if="errCurrentCoeff.length == 0" class="mainAnalyse__widget bilan">
        <!--{{ ultraDetailsArray }}-->
          <div class="bilan__title">Phase</div>
          <select name="phases" id="phase" v-model="ultraDetailsPhaseSelected">
            <option value="all">Toutes les phases</option>
            <option v-for="phase in phases" :key="phase.id" :value="phase.id">{{ phase.name }}</option>
          </select>
          <!--{{ ultraDetailsPhaseSelected }}-->
          <div class="bilan__title">Temps passés</div>
          <div class="details_grid bilan__legend">
              <span class="details_name">Prenom</span>
              <span class="details_surname">Nom</span>
              <span class="details_time">Temps passés</span>
              <span class="details_sbj">Salaire Brut Journalier (moyen)</span>
              <!--<span class="details_coeff">Coeff</span>-->
              <span class="details_montant">Montant €</span>
          </div>
          <div
            v-for="line in filteredUltraDetails"
            :key="line.userId + (ultraDetailsPhaseSelected !== 'all' ? line.phaseId : '')"
            class="details_grid bilan__line"
          >
            <span class="details_name">{{ line.userName }}</span>
            <span class="details_surname">{{ line.userSurname }}</span>
            <span class="details_time">{{ line.totalJours.toFixed(1) }}</span>
            <span class="details_sbj">{{ line.sbjPondere.toFixed(0)}}</span>
            <span class="details_montant"> {{ updateMontant((line.montants?.[$store.state.auth.currentCoeff] ?? 0).toFixed(2)).str }} €</span>
          </div>
          <div class="bilan__grid bilan__legend">
          </div>
          <div class="details_grid bilan__line">
            <span class="details_time"> {{ totalJoursUltraDetails.toFixed(1) }} jours</span>
            <span class="details_total">± Total</span>
            <span class="details_montant">{{updateMontant(totalMontantAffiche.toFixed(2)).str}}€ </span>
          </div>

          
          <div class="bilan__title">Frais</div>
          <div class="details_grid bilan__legend">
            <span class="details_date">Date</span>
            <span class="details_type">Catégorie</span>
            <span class="details_phase">Type</span>
            <span class="details_objet">Objet</span>
            <span class="details_montant">Montant €</span>
          </div>
          <div v-if="filteredFrais.length === 0" class="bilan__empty">
            Aucun frais sur la période
          </div>

          <div
            v-else
            v-for="(f, idx) in filteredFrais"
            :key="f.phaseId + '_' + f.date + '_' + idx"
            class="details_grid bilan__line"
          >
            <span class="details_date">
              {{ new Date(f.date).toLocaleDateString('fr-FR') }}
            </span>

            <span class="details_type">{{ f.cat }}</span>
            <span class="details_phase">{{ f.type }}</span>
            <span class="details_objet">{{ f.objet || '—' }}</span>

            <span class="details_montant">
              {{ updateMontant((Number(f.montant) || 0).toFixed(2)).str }} €
            </span>
          </div>

          <!-- Ligne TOTAL -->
          <div class="details_grid bilan__legend">
          </div>
          <div class="details_grid bilan__line">
            <span class="details_total">± Total</span>
            <span class="details_montant">{{updateMontant( totalFraisAffiche.toFixed(2)).str}} €</span>
          </div>

          <!--
          <div class="details_grid bilan__line" v-for="frais in analyseProjet.frais" :key="frais.id">
            <span class="details_date">{{dateToNiceStr(frais.date)}}</span>
            <span class="details_type">{{frais.type}}</span>
            <span class="details_phase">{{(frais.labelName)}}</span>
            <span class="details_objet">{{frais.objet}}</span>
            <span class="details_montant">{{updateMontant(frais.montant).str}}€</span>
          </div>
          <div class="details_grid bilan__legend">
          </div>
          <div class="details_grid bilan__line">
            <span class="details_total">± Total</span>
            <span class="details_montant">{{updateMontant(getAnalyseTt.ttFrais.toFixed(2)).str}} €</span>
          </div>
          <div class="bilan__title">Factures</div>
          <div class="details_grid bilan__legend">
            <span class="details_date">Date</span>
            <span class="détails_numero">n°</span>
            <span class="details_phase">Phase</span>
            <span class="details_montant">Montant HT</span>
          </div>
          <div class="details_grid bilan__line" v-for="facture in analyseProjet.factures" :key="facture.id">
            <span class="details_date">{{dateToNiceStr(facture.date)}}</span>
            <span class="détails_numero">{{facture.numero}}</span>
            <span class="details_phase">{{facture.phase}}</span>
            <span class="details_montant">{{updateMontant(facture.montantHT).str}}€</span>
          </div>
          <div class="details_grid bilan__legend">
          </div>
          <div class="details_grid bilan__line">
            <span class="details_total">± Total</span>
            <span class="details_montant">{{updateMontant(getAnalyseTt.ttFacture.toFixed(2)).str}}€</span>
          </div>
          -->
          <div class="bilan__title">Résultat</div>
          <div class="details_grid bilan__legend">
          </div>
          <div class="details_grid bilan__line">
            <span class="details_total">± Total</span>
            <!--<span class="details_montant" :class="styleDelta(total(etudes))">{{updateMontant(totalFraisAffiche.toFixed(2)).str}}€</span>-->
            <span class="details_montant">{{updateMontant((totalFraisAffiche + totalMontantAffiche).toFixed(2)).str}}€</span>
          </div>
        </div>
      </template>
    </Section>
  </div>

    <!-- <div>
        <div v-for="phase in phases" :key="phase._id">
          {{phase.name}} : {{phase.jours}} j
        </div>
    </div> -->
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../assets/main.scss';

.mainWidth{
  grid-column: 1 / span 3
}

.mainAnalyse{
  @include grid-alpha-noFirst;

  &__widget{
    @include myBlock;
    padding: 20px;

    &__erreur{
      color: $alert;
      @include myFont;
      font-size: 13px;
    }
  }
}

.bilanGlobal{
  grid-column: 1 / span 3;
}

.bilan{
  &__title{
    @include myFont;
    color: $main;
    font-size: 16px;
    font-weight: 600;
    margin: 30px 0 0 0;
  }

  &__grid{
    display: grid;
    grid-template-columns: 180px repeat(9, 1fr);
    text-align: right;

    & :nth-child(1){
      text-align: left;
    }

    // & :nth-last-child(1){
    //   text-align: right;
    // }
  }

  &__legend{
    @include myFont;
    color: $black-bold;
    font-size: 11px;
    padding: 0 0 5px 0;
    border-bottom: solid 1px $black;

    & span{
      align-self: center;
    }
  }

  &__line{
    @include myFont;
    font-size: 13px;
    color: $black-bolder;
    margin: 5px 0;

    & span{
      @include monoline;
    }
  }

  &__alert{
    color: $alert-light;
  }

  &__green{
    color: $green;
  }

  &__total{
    border-top: solid 1px $black;
    padding: 5px 0 0 0;
    @include myFont;
    font-size: 13px;
    color: $black-bolder;


    & :nth-child(1){
      font-weight: 600;
      color: black;
    }
  }

  &__megaTotal{
    border-top: solid 1px $black;
    border-bottom: solid 1px $black;
    padding: 5px 0 5px 0;
    @include myFont;
    font-size: 13px;
    color: $black-bolder;
    margin: 0 0 10px 0;
    background-color: rgb(245, 245, 245);
    font-weight: 600;
    color: black;
  }
}

.details{
  &_grid{
    display: grid;
    grid-template-columns: 2fr 1fr 1fr 3fr 2fr 2fr 1fr 2fr;
  }

  &_name{
    grid-column: 1;
  }

  &_surname{
    grid-column: 2 / span 3;
  }

  &_time{
    grid-column: 5;
    // justify-self: center;
  }

  &_sbj{
    grid-column: 6;
    // justify-self: center;  
    // text-align: center;
  }

  &_coeff{
    grid-column: 7;
    // justify-self: center;
  }

  &_total{
    grid-column: 7;
    // justify-self: center;
    @include myFont;
    color: $black-bold;
    font-size: 11px;
  }

  &_montant{
    grid-column: 8;
    justify-self: flex-end;
  }

  &_date{
    grid-column: 1;
  }

  &_type{
    grid-column: 2 / span 2;
  }

  &_phase{
    grid-column: 4;
  }

  &_objet{
    grid-column: 5 / span 3;
  }

  &_numero{
    grid-column: 2 / span 2;
  }
}


</style>
